import React from 'react'
import { Button, ButtonGroup, Typography, CircularProgress } from '@material-ui/core'
import { useMediaQuery } from "@material-ui/core";


const countTotalItemsInCart = (item) => {
    let totalItemsInCart = 0
    item.forEach(config => totalItemsInCart += parseInt(config.quantity))
    return totalItemsInCart
}

const FancyButton = (props) => {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const buttonProps = {
        variant: isSmallScreen ? "contained" : "contained",
        size: isSmallScreen ? "small" : "medium",
        color: 'secondary'
    };


    const { foodItem, cart, cartChangeToken, leftClick, rightClick, customization, cartLoading, ...rest } = props
    if (cart.hasOwnProperty(foodItem.id) && cart[foodItem.id].length > 0) {
        const foundArrayItem = cart[foodItem.id]
        return (
            <ButtonGroup {...buttonProps} aria-label={cartChangeToken} >
                <Button onClick={() => leftClick({ itemId: foodItem.id, configId: foundArrayItem[0].configId })}>
                    -
                </Button>
                <Button>{cartLoading ? <CircularProgress size={12} color="primary" /> : countTotalItemsInCart(foundArrayItem)}</Button>
                <Button onClick={rightClick} >+</Button>
            </ButtonGroup>
        )
    }

    return (
        <div style={{ textAlign: 'right' }} {...rest}>
            <Button

                {...buttonProps}
                aria-label={cartChangeToken}
                onClick={rightClick}
            >
                ADD  {customization && <span> + </span>}
            </Button>
            {/* style={{ position: 'absolute', bottom: '-20px', left: '0' }} */}
            {customization && <Typography component="p" variant="caption"  >Customisable</Typography>}
        </div >
    )

}

export default FancyButton